var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.038,
    height: 45.057,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 327",
    d: "M.68 22.045L15.695.734a.4.4 0 01.538-.153.731.731 0 01.305.638V43.84a.731.731 0 01-.306.637.4.4 0 01-.538-.154L.68 23.014a.9.9 0 010-.968",
    fill: "#8c93b0",
    stroke: "#8c93b0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevArrowIcon);
export default __webpack_public_path__ + "static/media/prevArrowIcon.e10f6f29837b7644.svg";
export { ForwardRef as ReactComponent };